async function cartBundleChecking(cart) {
    const bundle_checklist = {};
    for (let item of cart.items) {
        for (const key of Object.keys(item.properties)) {
            if (key == "Bundle ID") {
                if (!bundle_checklist[item.properties[key]]) {
                    bundle_checklist[item.properties[key]] = [item.key]
                } else {
                    bundle_checklist[item.properties[key]]?.push(item.key);
                }

                break;
            }
        }
    }

    var updates = {};
    for (const bundleId of Object.keys(bundle_checklist)) {
        if (bundle_checklist[bundleId].length < 2) {
            for (const line_item_key of bundle_checklist[bundleId]) {
                updates = {
                    ...updates,
                    [line_item_key]: 0
                }
            }
        }
    }

    await fetch(`${Shopify.routes.root}cart/update.js`, {
        body: JSON.stringify({ updates }),
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest"
            // Needed for Shopify to check inventory
        }
    });

    // refresh the cart
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
    }));

    return Object.keys(updates).length > 0;
}

document.addEventListener('DOMContentLoaded', async function() {
    const response = await fetch(`${Shopify.routes.root}cart.js`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest"
            // Needed for Shopify to check inventory
        }
    });

    const cart = await response.json();
    const ok = await cartBundleChecking(cart);
    if (ok) { 
        location.reload();
    }
});

document.addEventListener('cart:change', async function(event) {
    let cart = event.detail.cart; // Get the updated content of the cart
    let baseEvent = event.detail.baseEvent; // Get the base event

    if (window.themeVariables.settings.pageType !== "cart" && baseEvent == "line-item:change") {
        await cartBundleChecking(cart);
    }
});